import Vue from 'vue'
import filtrarEmailLar21ComoSistema from './filtrarEmailLar21ComoSistema'

Vue.filter('emailSistema', filtrarEmailLar21ComoSistema)
